export default __webpack_public_path__ + "static/media/walletConnectIcon.304e3277.svg";